import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "remove",
  "use": "remove-usage",
  "viewBox": "0 0 9.031 9.031",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 9.031 9.031\" id=\"remove\"><path d=\"M5.219 4.405 8.644.888a.534.534 0 0 0 0-.739.499.499 0 0 0-.719 0L4.499 3.667 1.075.149a.5.5 0 0 0-.72 0 .534.534 0 0 0 0 .739L3.78 4.405.145 8.139a.532.532 0 0 0 0 .739.499.499 0 0 0 .719 0l3.635-3.734 3.636 3.734a.499.499 0 0 0 .719 0 .534.534 0 0 0 0-.739L5.219 4.405Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol